import { Box } from "@mui/material";

import { withForm } from "components/Forms/AppForm";

import { pcmFormDefaultValues } from "./pcmFormDefaultValues";

const MaintenanceCheckboxSection = withForm({
  defaultValues: pcmFormDefaultValues,
  props: {},
  render: function Render({ form }) {
    const isMaintenanceLabel =
      "Select if this is for inclusion of a maintenance release to an already listed international product.";

    return (
      <Box sx={{ mb: 4 }}>
        <form.AppField
          name="isMaintenance"
          listeners={{
            onChange: () => {
              // Reset downstream fields when maintenance toggle changes
              // Data fetching is handled reactively by usePcmCascadingData
              form.resetField("ccProduct");
              form.resetField("ccMaintenance");
            },
          }}
        >
          {(field) => <field.SingleCheckbox label={isMaintenanceLabel} />}
        </form.AppField>
      </Box>
    );
  },
});

export default MaintenanceCheckboxSection;
